import { useQuery } from '@tanstack/react-query';
import ServerError from '../../errors/ServerError';
import SM from '../../services/ServiceManager';

export const useGetContact = ({
    contactId, enabled = false,
}) => {
    const result = useQuery({
        queryKey: ['getContactDetails', contactId],
        enabled: !!contactId && enabled,
        retry: false,
        queryFn: async () => {
            const { data } = await SM.clientService('getContact', [contactId]);

            return data;
        },
    });

    return {
        ...result,
        error: result.error ? new ServerError(result.error) : result.error,
        statusCode: result?.data?.status,
    };
};
